import React from 'react'
import { Switch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import IndexRedirect from '../../../organisms/HomeDashboard/IndexRedirect'
import { useCheckPolicy } from '../../../../hooks'
import NotAvailable from '../../../organisms/NotAvailable'
import AdminPage from '../shared/AdminPage'
import AdminRequestsHomeIndex from './IndexView'
import AdminRequestItem from './ItemView'

function AdminRequestsHome () {
  const hasAccess = useCheckPolicy('admin_connection_requests')

  if (!hasAccess) {
    return <NotAvailable />
  }

  return (
    <AdminPage>
      <Switch>
        <SecureRoute path='/admin/requests' exact>
          <AdminRequestsHomeIndex />
        </SecureRoute>
        <SecureRoute path='/admin/requests/item' exact>
          <IndexRedirect to='/admin/requests' />
        </SecureRoute>
        <SecureRoute path='/admin/requests/item/:requestId' exact>
          <AdminRequestItem />
        </SecureRoute>
      </Switch>
    </AdminPage>
  )
}

export default AdminRequestsHome
